// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"92d10452","904":"a0f58955"}[chunkId] + ".chunk.css";
};